import ReactGA from 'react-ga4';

// Google Analytics Measurement ID
const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-6N692L4D1D';

export const initGA = () => {
  ReactGA.initialize(MEASUREMENT_ID, {
    gaOptions: {
      anonymizeIp: true, // For GDPR compliance
    },
  });
};

export const trackPageView = (path) => {
  ReactGA.send({ hitType: 'pageview', page: path });
};

export const trackEvent = (category, action, label, value) => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};

// Custom events for Savvy Academy
export const trackCourseView = (courseSlug, courseName) => {
  ReactGA.event({
    category: 'Course',
    action: 'View',
    label: courseName || courseSlug,
  });
};

export const trackUnitView = (unitSlug, unitName) => {
  ReactGA.event({
    category: 'Unit',
    action: 'View',
    label: unitName || unitSlug,
  });
};

export const trackSignup = (method) => {
  ReactGA.event({
    category: 'User',
    action: 'Signup',
    label: method, // 'mobile' or 'email'
  });
};

export const trackLogin = (method) => {
  ReactGA.event({
    category: 'User',
    action: 'Login',
    label: method,
  });
};

export const trackVideoPlay = (videoId, videoTitle) => {
  ReactGA.event({
    category: 'Video',
    action: 'Play',
    label: videoTitle || videoId,
  });
};

export const trackQuizSubmit = (quizId, score) => {
  ReactGA.event({
    category: 'Quiz',
    action: 'Submit',
    label: quizId,
    value: score,
  });
};
